export interface GameSettings {
  highContrast: boolean;
  reduceMotion: boolean;
  fontSize: 'normal' | 'large';
  colorblindMode: boolean;
  keyBindings: {
    up: string;
    down: string;
    left: string;
    right: string;
    pause: string;
  };
}

export const defaultSettings: GameSettings = {
  highContrast: false,
  reduceMotion: false,
  fontSize: 'normal',
  colorblindMode: false,
  keyBindings: {
    up: 'W',
    down: 'S',
    left: 'A',
    right: 'D',
    pause: 'ESC',
  }
};

export function loadSettings(): GameSettings {
  const s = localStorage.getItem('neon_maw_settings');
  if (s) {
    try { 
      const parsed = JSON.parse(s);
      return { ...defaultSettings, ...parsed, keyBindings: { ...defaultSettings.keyBindings, ...(parsed.keyBindings || {}) } };
    } catch {}
  }
  return defaultSettings;
}

export function saveSettings(s: GameSettings) {
  localStorage.setItem('neon_maw_settings', JSON.stringify(s));
}
